(ns app.front.ui.email-toggle
  (:require [core.front.carbon :as cc]
            [core.front.icons :as i]))

(defn email-toggle [{:keys [tr notifications-enabled? on-toggle]}]
  [:div.flex.items-center.leading-tight.mb-2
   (cc/icon {:icon        i/bell
             :description (tr [:application/email-subscription])
             :fill        "#0F3FD2"
             :height      "1em"
             :aria-hidden true})
   [:span.mx-2 (tr [:application/email-subscription])]
   (cc/toggle {:id         "email-subscription"
               :data-cy    "email-subscription"
               :class-name "subscription-toggle unlabeled-toggle"
               :size       :sm
               :labelA     (tr [:false])
               :labelB     (tr [:true])
               :aria-label (tr [:application/email-subscription])
               :toggled    notifications-enabled?
               :on-toggle  on-toggle})])
